module.exports = __webpack_public_path__ + "img/product_6.b30f181.jpg";